module.exports = {"510724101":"桑枣镇","510724102":"花荄镇","510724103":"黄土镇","510724104":"塔水镇","510724105":"秀水镇","510724106":"河清镇","510724108":"界牌镇","510724109":"永河镇","510724110":"雎水镇","510724111":"清泉镇","510724112":"宝林镇","510724113":"沸水镇","510724114":"晓坝镇","510724115":"乐兴镇","510724116":"千佛镇","510724201":"兴仁乡","510724202":"高川乡","510724203":"迎新乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510724.json
// module id = 2124
// module chunks = 0